import { render, staticRenderFns } from "./groupManage.vue?vue&type=template&id=60fa1aae&scoped=true"
import script from "./groupManage.vue?vue&type=script&lang=js"
export * from "./groupManage.vue?vue&type=script&lang=js"
import style0 from "./groupManage.vue?vue&type=style&index=0&id=60fa1aae&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fa1aae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60fa1aae')) {
      api.createRecord('60fa1aae', component.options)
    } else {
      api.reload('60fa1aae', component.options)
    }
    module.hot.accept("./groupManage.vue?vue&type=template&id=60fa1aae&scoped=true", function () {
      api.rerender('60fa1aae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_homeCloudPlatform/group/groupManage.vue"
export default component.exports